/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M10 17H10.01M14 17H14.01M10.5 17C10.5 17.2761 10.2761 17.5 10 17.5C9.72386 17.5 9.5 17.2761 9.5 17C9.5 16.7239 9.72386 16.5 10 16.5C10.2761 16.5 10.5 16.7239 10.5 17ZM14.5 17C14.5 17.2761 14.2761 17.5 14 17.5C13.7239 17.5 13.5 17.2761 13.5 17C13.5 16.7239 13.7239 16.5 14 16.5C14.2761 16.5 14.5 16.7239 14.5 17ZM15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4 10C4 7.19974 4 5.79961 4.54497 4.73005C5.02433 3.78924 5.78924 3.02433 6.73005 2.54497C7.79961 2 9.19974 2 12 2V2C14.8003 2 16.2004 2 17.27 2.54497C18.2108 3.02433 18.9757 3.78924 19.455 4.73005C20 5.79961 20 7.19974 20 10V14C20 16.8003 20 18.2004 19.455 19.27C18.9757 20.2108 18.2108 20.9757 17.27 21.455C16.2004 22 14.8003 22 12 22V22C9.19974 22 7.79961 22 6.73005 21.455C5.78924 20.9757 5.02433 20.2108 4.54497 19.27C4 18.2004 4 16.8003 4 14V10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20 10C20 7.19974 20 5.79961 19.455 4.73005C18.9757 3.78924 18.2108 3.02433 17.27 2.54497C16.2004 2 14.8003 2 12 2C9.19974 2 7.79961 2 6.73005 2.54497C5.78924 3.02433 5.02433 3.78924 4.54497 4.73005C4 5.79961 4 7.19974 4 10V14C4 16.8003 4 18.2004 4.54497 19.27C5.02433 20.2108 5.78924 20.9757 6.73005 21.455C7.79961 22 9.19974 22 12 22C14.8003 22 16.2004 22 17.27 21.455C18.2108 20.9757 18.9757 20.2108 19.455 19.27C20 18.2004 20 16.8003 20 14V10ZM12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12Z"
				fill="currentColor"
			/>
			<path
				d="M10 17H10.01M14 17H14.01M10.5 17C10.5 17.2761 10.2761 17.5 10 17.5C9.72386 17.5 9.5 17.2761 9.5 17C9.5 16.7239 9.72386 16.5 10 16.5C10.2761 16.5 10.5 16.7239 10.5 17ZM14.5 17C14.5 17.2761 14.2761 17.5 14 17.5C13.7239 17.5 13.5 17.2761 13.5 17C13.5 16.7239 13.7239 16.5 14 16.5C14.2761 16.5 14.5 16.7239 14.5 17ZM15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9ZM12 22V22C14.8003 22 16.2004 22 17.27 21.455C18.2108 20.9757 18.9757 20.2108 19.455 19.27C20 18.2004 20 16.8003 20 14V10C20 7.19974 20 5.79961 19.455 4.73005C18.9757 3.78924 18.2108 3.02433 17.27 2.54497C16.2004 2 14.8003 2 12 2V2C9.19974 2 7.79961 2 6.73005 2.54497C5.78924 3.02433 5.02433 3.78924 4.54497 4.73005C4 5.79961 4 7.19974 4 10V14C4 16.8003 4 18.2004 4.54497 19.27C5.02433 20.2108 5.78924 20.9757 6.73005 21.455C7.79961 22 9.19974 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.25 22.75C8.44974 22.75 7.04961 22.75 5.98005 22.205C5.03924 21.7257 4.27433 20.9608 3.79497 20.02C3.25 18.9504 3.25 17.5503 3.25 14.75V9.25C3.25 6.44974 3.25 5.04961 3.79497 3.98005C4.27433 3.03924 5.03924 2.27433 5.98005 1.79497C7.04961 1.25 8.44974 1.25 11.25 1.25H12.75C15.5503 1.25 16.9504 1.25 18.02 1.79497C18.9608 2.27433 19.7257 3.03924 20.205 3.98005C20.75 5.04961 20.75 6.44974 20.75 9.25V14.75C20.75 17.5503 20.75 18.9504 20.205 20.02C19.7257 20.9608 18.9608 21.7257 18.02 22.205C16.9504 22.75 15.5503 22.75 12.75 22.75H11.25ZM12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12ZM11 17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17C9 16.4477 9.44772 16 10 16C10.5523 16 11 16.4477 11 17ZM14 18C14.5523 18 15 17.5523 15 17C15 16.4477 14.5523 16 14 16C13.4477 16 13 16.4477 13 17C13 17.5523 13.4477 18 14 18Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M10 17H10.01M14 17H14.01M20 10V9.5V9.5C20 7.17029 20 6.00544 19.6194 5.08658C19.1119 3.86144 18.1386 2.88807 16.9134 2.3806C15.9946 2 14.8297 2 12.5 2H12C9.19974 2 7.79961 2 6.73005 2.54497C5.78924 3.02433 5.02433 3.78924 4.54497 4.73005C4 5.79961 4 7.19974 4 10V14C4 16.8003 4 18.2004 4.54497 19.27C5.02433 20.2108 5.78924 20.9757 6.73005 21.455C7.79961 22 9.19974 22 12 22H12.5C14.8297 22 15.9946 22 16.9134 21.6194C18.1386 21.1119 19.1119 20.1386 19.6194 18.9134C20 17.9946 20 16.8297 20 14.5V14.5V14M10.5 17C10.5 17.2761 10.2761 17.5 10 17.5C9.72386 17.5 9.5 17.2761 9.5 17C9.5 16.7239 9.72386 16.5 10 16.5C10.2761 16.5 10.5 16.7239 10.5 17ZM14.5 17C14.5 17.2761 14.2761 17.5 14 17.5C13.7239 17.5 13.5 17.2761 13.5 17C13.5 16.7239 13.7239 16.5 14 16.5C14.2761 16.5 14.5 16.7239 14.5 17ZM15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M14 17H14.01M14.5 17C14.5 17.2761 14.2761 17.5 14 17.5C13.7239 17.5 13.5 17.2761 13.5 17C13.5 16.7239 13.7239 16.5 14 16.5C14.2761 16.5 14.5 16.7239 14.5 17ZM15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9ZM12 22V22C14.8003 22 16.2004 22 17.27 21.455C18.2108 20.9757 18.9757 20.2108 19.455 19.27C20 18.2004 20 16.8003 20 14V10C20 7.19974 20 5.79961 19.455 4.73005C18.9757 3.78924 18.2108 3.02433 17.27 2.54497C16.2004 2 14.8003 2 12 2V2C9.19974 2 7.79961 2 6.73005 2.54497C5.78924 3.02433 5.02433 3.78924 4.54497 4.73005C4 5.79961 4 7.19974 4 10V14C4 16.8003 4 18.2004 4.54497 19.27C5.02433 20.2108 5.78924 20.9757 6.73005 21.455C7.79961 22 9.19974 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.25 22.75C8.44974 22.75 7.04961 22.75 5.98005 22.205C5.03924 21.7257 4.27433 20.9608 3.79497 20.02C3.25 18.9504 3.25 17.5503 3.25 14.75V9.25C3.25 6.44974 3.25 5.04961 3.79497 3.98005C4.27433 3.03924 5.03924 2.27433 5.98005 1.79497C7.04961 1.25 8.44974 1.25 11.25 1.25H12.75C15.5503 1.25 16.9504 1.25 18.02 1.79497C18.9608 2.27433 19.7257 3.03924 20.205 3.98005C20.75 5.04961 20.75 6.44974 20.75 9.25V14.75C20.75 17.5503 20.75 18.9504 20.205 20.02C19.7257 20.9608 18.9608 21.7257 18.02 22.205C16.9504 22.75 15.5503 22.75 12.75 22.75H11.25Z"
				fill="currentColor"
			/>
			<path
				d="M12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12Z"
				fill="currentColor"
			/>
			<path
				d="M10 18C10.5523 18 11 17.5523 11 17C11 16.4477 10.5523 16 10 16C9.44772 16 9 16.4477 9 17C9 17.5523 9.44772 18 10 18Z"
				fill="currentColor"
			/>
			<path
				d="M14 18C14.5523 18 15 17.5523 15 17C15 16.4477 14.5523 16 14 16C13.4477 16 13 16.4477 13 17C13 17.5523 13.4477 18 14 18Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
